import React from 'react';
import { CalculatorInput } from '../components/CalculatorInput';
import { CalculatorOutput } from '../components/CalculatorOutput';

export function Economical(): JSX.Element {

    return (
        <section className="calculator">

            {/* on garde pour la MEP */}
            <div className="utilities">
            </div>

            <CalculatorInput/>

            <CalculatorOutput/>

        </section>
    );
}
